import React from 'react';
import PropTypes from 'prop-types';

import './WidgetHeader.scss';

const WidgetHeader = ({
  text
}) => (
  <div className='widget-header'>
    {text}
  </div>
);

WidgetHeader.defaultProps = {
  text: ''
};

WidgetHeader.propTypes = {
  text: PropTypes.string
};

export default WidgetHeader;
